const LOGIN_REDIRECT_KEY = 'totem.postLoginRedirect';

export const setPostLoginRedirect = (path: string) => {
  if (!path || path === '/login') {
    return;
  }

  sessionStorage.setItem(LOGIN_REDIRECT_KEY, path);
};

export const consumePostLoginRedirect = () => {
  const path = sessionStorage.getItem(LOGIN_REDIRECT_KEY);

  if (path) {
    sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
  }

  return path;
};

export const peekPostLoginRedirect = () => {
  return sessionStorage.getItem(LOGIN_REDIRECT_KEY);
};
